export default __webpack_public_path__ + "static/media/fullscreen-mobile-screens.6534b8fa.jpg";